export class OperatorContextModel {
  public chatWelcomeMessageId;
  public textChatWelcomeMessageId;
  public useAnswerNext;
  public clientId;

  constructor() {
    this.chatWelcomeMessageId = null;
    this.textChatWelcomeMessageId = null;
    this.useAnswerNext = false;
    this.clientId = null;
  }
}
